import React from 'react';
import { Typography } from '@mui/material';

export default function FieldLabel({ label, children }) {
    return (
        <Typography
            variant="caption"
            component="div"
            sx={{
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: 0.5,
                fontSize: 10,
                fontWeight: 600,
                mb: children ? 0.5 : 0,
            }}
        >
            {label}
            {children}
        </Typography>
    );
}
